import FormatCurrency from "../../Homepage/components/FormatCurrency";
import PaymentBarTooltip from "./PaymentBarTooltip/PaymentBarTooltip";
import React from "react";
import { compose } from "redux";
import withTranslations from "../../../../../../hocs/withTranslations";
import classNames from "classnames";
import useIsDesktop from "../../../hooks/useIsDesktop";

const SelectedPlanPrice = ({
  hasSubtractedAmount,
  paymentMethodPricing,
  translate,
  locale
}) => {
  const isDesktop = useIsDesktop();

  return (
    <div className={"flex gap-4 align-center"}>
      <span className={"text-xs text-black opacity-65"}>
        {translate("plans_payment-bar_price")}
      </span>
      <div className={"flex align-center flex-wrap"}>
        {hasSubtractedAmount ? (
          <span className={"text-xl text-black opacity-70 font-bold"}>
            <span>
              <FormatCurrency
                locale={locale}
                value={paymentMethodPricing?.offer_amount ?? 0}
              />
            </span>
            <span className={"px-1"}>-</span>
            <span>
              <FormatCurrency
                locale={locale}
                value={paymentMethodPricing?.subtracted_amount ?? 0}
              />
            </span>
            <span className={"text-xs.1 font-medium px-1"}>
              {translate("plans_payment-bar_includes-discounts")}
            </span>
            <PaymentBarTooltip
              prorationAmount={paymentMethodPricing?.proration_amount}
              affiliationDiscountAmount={
                paymentMethodPricing?.affiliation_discount_amount
              }
              discountAmount={paymentMethodPricing?.discount_amount}
              subtractedAmount={paymentMethodPricing?.subtracted_amount}
            />
          </span>
        ) : null}
        <strong
          className={classNames("text-black font-bold z-10 mr-3", {
            "text-2xl": isDesktop,
            "text-xl": !isDesktop
          })}
        >
          {hasSubtractedAmount ? <span className={"px-1.5"}>=</span> : null}
          <FormatCurrency
            locale={locale}
            value={paymentMethodPricing?.order_amount ?? 0}
          />
        </strong>
      </div>
    </div>
  );
};

export default compose(withTranslations)(SelectedPlanPrice);
